import { render, staticRenderFns } from "./LmPageBreakBuilderUi.vue?vue&type=template&id=0b996492&"
import script from "./LmPageBreakBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmPageBreakBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports